var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.9987L8.75 11.6654V8.33203L11.6667 9.9987Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 10.5879V9.4087C1.66797 6.9962 1.66797 5.78953 2.42214 5.0137C3.17714 4.23703 4.36547 4.2037 6.7413 4.1362C7.8663 4.10453 9.0163 4.08203 10.0013 4.08203C10.9855 4.08203 12.1355 4.10453 13.2613 4.1362C15.6371 4.2037 16.8255 4.23703 17.5796 5.0137C18.3346 5.78953 18.3346 6.99703 18.3346 9.4087V10.5879C18.3346 13.0012 18.3346 14.207 17.5805 14.9837C16.8255 15.7595 15.638 15.7937 13.2613 15.8604C12.1363 15.8929 10.9863 15.9154 10.0013 15.9154C8.91443 15.9121 7.82766 15.8938 6.7413 15.8604C4.36547 15.7937 3.17714 15.7604 2.42214 14.9837C1.66797 14.207 1.66797 13.0004 1.66797 10.5887V10.5879Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.cdc248d02ade2736f78964fa926e3087.svg";
export { ForwardRef as ReactComponent };